/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { BEM } from "@adapptio/lib-components";
import React, { FC } from "react";

/**
 * Component props
 */
export interface IDialogButtonsProps {}

/**
 * Dialog Buttons
 * Styles action buttons for dialogs.
 *
 * @param props Component props
 */
export const DialogButtons: FC<IDialogButtonsProps> = ({ children }) => {
	const baseClass = BEM("edt-dialog", "buttons");

	return <div className={baseClass.toClassName()}>{children}</div>;
};
